import React, {Component} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import Loading from "../Loading";
import {downloadExcelSummaryByHo,downloadExcelDetailByHo} from "./utils/DownloadSupportHO.js";
import {Table} from "reactstrap";
import fileDownload from 'js-file-download';

class BankfeeDetailByHO extends Component{

    constructor(props) {
        super(props);
        const INITIAL_ITEM = {
            id:'',
            paymentMonth:'',
            code:'',
            name:'',
            designationCd:'',
            status:'',
            isConfirmed:'',
            resultFinal:'',
            commentContent:'',
            evidences:[],
        }
        this.state = {
            isLoading: false,
            successMessage: '',
            errorMessage: '',
            item:INITIAL_ITEM,
        }
        this.getBankfee = this.getBankfee.bind(this);
        this.onChangeComment = this.onChangeComment.bind(this);
        this.onChangeStatus = this.onChangeStatus.bind(this);
        this.downloadExcelSummaryByHo = downloadExcelSummaryByHo.bind(this);
        this.downloadExcelDetailByHo = downloadExcelDetailByHo.bind(this);
        this.downloadSummary = this.downloadSummary.bind(this);
        this.downloadDetail = this.downloadDetail.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        this.getBankfee(this.props?.id);
    }

    onChangeComment(e){
        const {item} = this.state;
        if(item?.isConfirmed !== 'Y'){
            item.commentContent = e?.target?.value;
            this.setState({item: item});
        }
    }
    onChangeStatus(e){
        const {item} = this.state;
        if(item?.isConfirmed !== 'Y'){
            item.status = e?.target?.value;
            this.setState({item: item});
        }
    }
    handleSubmit(){
        const {item} = this.state
        if(item?.status === '0'){
            this.setState({errorMessage: 'Vui lòng chọn tình trạng xử lý'})
            return ;
        }
        this.setState({isLoading: true})
        axios.post('/api/bankportal/bankfee/confirm', item)
            .then(response => {
                this.getBankfee(response.data?.id);
                this.setState({successMessage: 'Xác nhận thông tin thành công',errorMessage:'', isLoading: false})
            })
            .catch(error => {
                console.log(error);
                this.setState({errorMessage: error.message,successMessage:'', isLoading: false})
            })
        
    }
    getBankfee(id) {
        this.setState({isLoading: true})
        const responseBankfee = axios.get('/api/bankportal/bankfee/'+id)
        const responseEvidence = axios.get('api/bankportal/bankfee/evidence/list/'+id)
        Promise.all([responseBankfee, responseEvidence])
            .then((values) =>{
                let item =  values[0]?.data
                if(!!item){
                    item.evidences = values[1]?.data?.evidences
                    this.setState({ item: item, errorMessage: '',isLoading: false})
                }else{
                    this.setState({ item: this.state.item, errorMessage: 'Không tìm thấy dữ liệu !',successMessage:'',isLoading: false})
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
                this.setState({errorMessage: error.message,successMessage:'', isLoading: false});
            })
    }

    downloadSummary(){
        const {item} = this.state;
        const reportName = 'Báo cáo hoa hồng_Tổng hợp_'+item?.code+'_'+item?.paymentMonth;
        this.setState({isLoading: true});
        const reportSummary = axios.get('/api/bankportal/bankfee/report/summary/download/'+item?.id);
        const reportCommission = axios.get('/api/bankportal/bankfee/report/commission/download/'+item?.id);
        const reportComment = axios.get('/api/bankportal/bankfee/report/comment/download/'+item?.id);
        const reportCommissionBO = axios.get('/api/bankportal/bankfee/report/commissionBO/download/'+item?.id);
        Promise.all([reportSummary,reportCommission,reportComment,reportCommissionBO])
            .then((values) =>{
                this.downloadExcelSummaryByHo(item, values, reportName);
                this.setState({isLoading: false});
            })
            .catch(error => {
                console.error('There was an error!', error);
                this.setState({errorMessage: error.message,successMessage:'', isLoading: false});
            });
    }
    downloadDetail(){
        const {item} = this.state;
        const reportName = 'Commission_Detail_'+item?.code+'_'+item?.paymentMonth;
        this.setState({isLoading: true});
        const reportDetail = axios.get('/api/bankportal/bankfee/report/detail/download/'+item?.id);
        Promise.all([reportDetail])
            .then((values) =>{
                this.downloadExcelDetailByHo(item, values, reportName);
                this.setState({isLoading: false});
            })
            .catch(error => {
                console.error('There was an error!', error);
                this.setState({errorMessage: error.message,successMessage:'', isLoading: false});
            });
    }

    render() {
        const {item, isLoading,errorMessage, successMessage, reportVCB202203, reportVCB202204, reportVCB202205} = this.state;
        if(isLoading === true) return <Loading />;
        return (
            <div className={'report mx-5'}>
                <div className={'div-center'}>
                    <div className={'content'}>
                        { !!errorMessage && <div className={"alert alert-warning"} role="alert">{ errorMessage }</div> }
                        { !!successMessage && <div className={"alert alert-info"} role="alert">{ successMessage }</div> }
                        <h2 className="m-3 text-primary">HOA HỒNG BẢO HIỂM - KỲ: <span>{item?.paymentMonth}</span></h2>
                        <form>
                            <div className="form-group">
                                <label className="control-label col-sm-3" htmlFor="name">Ngân hàng</label>
                                <div className="col-sm-9">
                                    <span>{item?.bankCode === 'VCB'?'Vietcombank':''}</span>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-sm-3" htmlFor="name">Tên văn phòng</label>
                                <div className="col-sm-9">
                                    <span>{item?.name}</span>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-sm-6" htmlFor="name">Tải tập tin báo cáo (Excel):</label>
                                <div className="col-sm-12">
                                    <button type='button' onClick={this.downloadSummary} className="btn btn-link mr-1"><span>Báo cáo tổng hợp</span></button>
                                    |
                                    {item?.bankCode === 'VCB' && item?.paymentMonth >= '202201' &&
                                        <button type='button' onClick={() => {
                                            this.setState({isLoading: true});
                                            axios.get('/api/bankportal/bankfee/report/ho/download/'+item?.id, {responseType: 'blob',})
                                                .then((response) => {
                                                    fileDownload(response.data, 'Commission_Detail_'+item?.code+'_'+item?.paymentMonth+'_'+item?.bankCode+'.xlsx');
                                                    this.setState({isLoading: false});
                                                })
                                                .catch(error =>{
                                                    console.error('There was an error!', error);
                                                    this.setState({errorMessage: error.message,successMessage:'', isLoading: false});
                                                })
                                        }} className="btn btn-link">
                                            <span>Báo cáo chi tiết</span>
                                        </button>
                                    }

                                    { (item?.bankCode !== 'VCB' || item?.paymentMonth < '202201') &&
                                        <button type='button' onClick={this.downloadDetail} className="btn btn-link ml-1"><span>Báo cáo chi tiết</span></button>
                                    }
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-sm-3" htmlFor="commentContent">Phản hồi từ hội sở:</label>
                                <div className="col-sm-9">
                                    {item?.isConfirmed === 'Y' ?
                                        <textarea maxLength={200} readOnly={true} className="form-control"
                                                  id="commentContent" rows="5" value={item?.commentContent==null?'':item?.commentContent}/>
                                        : <textarea maxLength={200} onChange={this.onChangeComment}
                                                    className="form-control" id="commentContent" rows="5"
                                                    value={item?.commentContent==null?'':item?.commentContent}/>
                                    }
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-sm-3" htmlFor="status">Tình trạng xử lý:</label>
                                <div className="col-sm-9">
                                    {item?.isConfirmed === 'Y' ?
                                        <select disabled={true} id="status" className="form-control"
                                                value={item?.status}>
                                            <option value="0">Chưa xử lý</option>
                                            <option value="1">Đang xử lý</option>
                                            <option value="2">Đã xử lý xong có điều chỉnh</option>
                                            <option value="3">Đã xử lý xong không điều chỉnh</option>
                                        </select>
                                        :<select id="status" className="form-control"
                                                 value={item?.status} onChange={this.onChangeStatus}>
                                            <option value="0">Chưa xử lý</option>
                                            <option value="1">Đang xử lý</option>
                                            <option value="2">Đã xử lý xong có điều chỉnh</option>
                                            <option value="3">Đã xử lý xong không điều chỉnh</option>
                                        </select>
                                    }
                                </div>
                            </div>
                            <div className="form-group" >
                                <label className="control-label col-sm-6" htmlFor="evidences">Danh sách tài liệu:</label>
                                <div className="col-sm-12">
                                    <Table striped bordered hover size={"sm"}>
                                        <thead>
                                        <tr>
                                            <th>STT</th>
                                            <th>Tài liệu</th>
                                            <th>Chức năng</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {!!item.evidences && item.evidences.map((evidence, index) =>
                                            <tr key={evidence?.id}>
                                                <td className={'td-center'}>{index+1}</td>
                                                <td className={'td-middle'}>{evidence.fileName}</td>
                                                <td><button type='button' onClick={() => {
                                                    this.setState({isLoading: true});
                                                    axios.get('/api/bankportal/bankfee/evidence/download/'+evidence?.id, {responseType: 'blob',})
                                                        .then((response) => {
                                                            fileDownload(response.data, evidence.fileName);
                                                            this.setState({isLoading: false});
                                                        })
                                                        .catch(error =>{
                                                            console.error('There was an error!', error);
                                                            this.setState({errorMessage: error.message,successMessage:'', isLoading: false});
                                                        })
                                                }} className="btn btn-link"><span>Tải tập tin</span></button></td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Link to={'/bp/bankfee'} className="btn btn-success">Quay về</Link>
                                    {item?.isConfirmed !== 'Y' && <button type="button" onClick={this.handleSubmit} className="btn btn-primary ml-1">Xác nhận kết quả hoa hồng</button>}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
export default BankfeeDetailByHO;